import { render } from "./NewsNoticeInfo.vue?vue&type=template&id=741739c8&scoped=true"
import script from "./NewsNoticeInfo.vue?vue&type=script&lang=js"
export * from "./NewsNoticeInfo.vue?vue&type=script&lang=js"

import "./NewsNoticeInfo.vue?vue&type=style&index=0&id=741739c8&scoped=true&lang=css"

import exportComponent from "/Volumes/directory/IdeaProjects/Macau-Double-Color-Ball/Macau-Double-Color-Ball_Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741739c8"]])

export default __exports__